var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96 11.9593C10.8204 12.828 9.43276 13.3093 8.00002 13.3327C3.33335 13.3327 0.666687 7.99935 0.666687 7.99935C1.49595 6.45395 2.64611 5.10375 4.04002 4.03935M6.60002 2.82602C7.05891 2.7186 7.52873 2.66491 8.00002 2.66602C12.6667 2.66602 15.3334 7.99935 15.3334 7.99935C14.9287 8.75642 14.4461 9.46917 13.8934 10.126M9.41335 9.41268C9.23025 9.60918 9.00945 9.76678 8.76412 9.8761C8.51879 9.98541 8.25395 10.0442 7.98541 10.0489C7.71687 10.0537 7.45013 10.0043 7.20109 9.90368C6.95206 9.80309 6.72583 9.65337 6.53592 9.46345C6.346 9.27353 6.19628 9.04731 6.09569 8.79827C5.9951 8.54924 5.9457 8.2825 5.95044 8.01395C5.95518 7.74541 6.01396 7.48058 6.12327 7.23525C6.23258 6.98992 6.39019 6.76911 6.58669 6.58602M0.666687 0.666016L15.3334 15.3327",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.38821a87951d5083d91912a587ca51bd.svg";
export { ForwardRef as ReactComponent };